import { render, staticRenderFns } from "./FixedBenefitDetail.vue?vue&type=template&id=7b6db6da&scoped=true&"
import script from "./FixedBenefitDetail.vue?vue&type=script&lang=js&"
export * from "./FixedBenefitDetail.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/flexben.css?vue&type=style&index=0&id=7b6db6da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6db6da",
  null
  
)

export default component.exports